export const BuildInfo = {timestamp:1773250406000}
